module.exports = __webpack_public_path__ + "img/www.glassdoor.co.uk.45369d76.png";